<template>
  <div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
        <tr style="width: 100%">
          <th class="text-no-wrap">ID Flexy</th>
          <th class="text-no-wrap">Montant</th>
          <th class="text-no-wrap">Telephone</th>
          <th class="text-no-wrap">Type</th>
          <th class="text-no-wrap">État</th>
          <th class="text-no-wrap">Action</th>
        </tr>
        </thead>
        <tbody style="width: 100%">
        <tr>
          <td class="text-no-wrap">
            {{ item.flexy ? item.flexy.id : "-" }}
          </td>
          <td class="font-weight-medium gifty--text text-no-wrap">
            {{ CurrencyFormatting(item.flexy ? item.flexy.amount : 0) }} DZD
          </td>
          <td class="text-no-wrap">
            {{ item.flexy ? item.flexy.phone : "-" }}
          </td>
          <td class="text-no-wrap">
            {{ item.flexy ? item.flexy.type : "-" }}
          </td>
          <td class="text-no-wrap">
            <v-chip v-if="item.flexy" small
                    class="ma-2"
                    :color="$martship_states.colors[item.flexy.martship_state]"
                    text-color="white"
            >
              {{ $martship_states.texts[item.flexy.martship_state] }}
            </v-chip>
          </td>
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs"
                       :disabled="item.flexy.martship_state !== 'REFUNDED'"
                       color="orange"
                       fab
                       depressed
                       x-small
                       v-on="on"
                       @click="confirmDialog = true"
                >
                  <v-icon>mdi-reload</v-icon>
                </v-btn>
              </template>
              <span>Renvoyer Flexy</span>
            </v-tooltip>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-dialog v-model="confirmDialog" max-width="400">
      <v-card>
        <v-card-title class="text-h6">
          Confirmation
        </v-card-title>
        <v-card-text>
          Êtes-vous sûr de vouloir renvoyer ce Flexy
          <strong>{{ item.flexy ? item.flexy.phone : "" }}</strong> ?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="confirmDialog = false">
            Annuler
          </v-btn>
          <v-btn color="success" depressed :loading="isLoading" @click="resendFlexy">
            Confirmer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  props: ["item"],
  emits: ['refresh'],
  data() {
    return {
      isLoading: false,
      confirmDialog: false,
    };
  },
  methods: {
    resendFlexy() {
      this.isLoading = true;

      HTTP.post("/v1/support/resend-flexy", {
        flexy_id: this.item.flexy.id,
      })
          .then(() => {
            this.confirmDialog = false;

            this.$successMessage = `Le Flexy vers le numéro ${this.item.flexy.phone} a été renvoyé avec succès.`;

            this.$emit("refresh");
          })
          .catch((error) => {
            console.error(error);

            this.$errorMessage =
                error.response?.data?.message ||
                "Une erreur est survenue lors du renvoi du Flexy.";
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
  }
};
</script>